import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TemaConfiguracaoCardComponent } from './tema-configuracao-card/tema-configuracao-card.component';

@NgModule({
    declarations: [TemaConfiguracaoCardComponent],
    imports: [CommonModule, FormsModule, MatButtonToggleModule, MatCardModule, MatIconModule],
    exports: [TemaConfiguracaoCardComponent]
})
export class TemaModule { }
